import { RouteRecordRaw } from 'vue-router'
// 路由

/**
 * meta:{
 *     title:'登录', 页面标题/菜单标题
 *     icon:'',     菜单图标
 *     hidden:true, 是否在菜单中以隐藏
 *     hiddenTab:true 是否在tab栏中隐藏
 *     permission: 角色权限
 * }
 */

export const commonRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/home',
    meta: {
      title: '首页',
      icon: 'dashboard'
    },
    children: [{
      path: '/home',
      name: 'home',
      component: () => import('@/views/admin/dashboard/index.vue'),
      meta: {
        title: '仪表盘',
        icon: ''
      },
    }]
  },
  // 内容管理
  {
    path: '/content',
    component: () => import('@/layout/index.vue'),
    redirect: '/content/articles',
    meta: {
      title: '内容管理',
      icon: 'edit'
    },
    children: [
      {
        path: 'articles',
        name: 'articles',
        component: () => import('@/views/admin/content/articles.vue'),
        meta: {
          title: '文章管理',
          icon: ''
        },
      },
       {
        path: 'messages',
        name: 'messages',
        component: () => import('@/views/admin/system/messages.vue'),
        meta: {
          title: '留言管理',
          icon: ''
        },
      },
      {
        path: 'article-edit',
        name: 'article-edit',
        component: () => import('@/views/admin/content/article-edit.vue'),
        meta: {
          title: '文章管理',
          icon: '',
           hidden: true,
            hiddenTab: true
        },
      }
    ]
  },
  // 业务管理
  {
    path: '/business',
    component: () => import('@/layout/index.vue'),
    redirect: '/business/lawyers',
    meta: {
      title: '业务管理',
      icon: 'user'
    },
    children: [
      {
        path: 'lawyers',
        name: 'lawyers',
        component: () => import('@/views/admin/business/lawyers.vue'),
        meta: {
          title: '律师管理',
          icon: ''
        },
      },
       {
        path: 'lawyer-edit',
        name: 'lawyer-edit',
        component: () => import('@/views/admin/business/lawyer-edit.vue'),
        meta: {
          title: '律师管理',
          icon: '',
          hidden: true,
            hiddenTab: true
        },
      },
      {
        path: 'practices',
        name: 'practices',
        component: () => import('@/views/admin/business/practices.vue'),
        meta: {
          title: '专业领域',
          icon: ''
        },
      },
      {
        path: 'clients',
        name: 'clients',
        component: () => import('@/views/admin/business/clients.vue'),
        meta: {
          title: '合作客户',
          icon: ''
        },
      },
      // {
      //   path: 'jobs',
      //   name: 'jobs',
      //   component: () => import('@/views/admin/business/jobs.vue'),
      //   meta: {
      //     title: '招聘管理',
      //     icon: ''
      //   },
      // }
    ]
  },
  // 系统管理
  {
    path: '/system',
    component: () => import('@/layout/index.vue'),
    redirect: '/system/banners',
    meta: {
      title: '系统管理',
      icon: 'system'
    },
    children: [
      {
        path: 'banners',
        name: 'banners',
        component: () => import('@/views/admin/system/banners.vue'),
        meta: {
          title: '轮播图管理',
          icon: ''
        },
      },
      {
        path: 'categories',
        name: 'categories',
        component: () => import('@/views/admin/content/categories.vue'),
        meta: {
          title: '栏目管理',
          icon: ''
        },
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('@/views/admin/system/settings.vue'),
        meta: {
          title: '站点设置',
          icon: ''
        },
      }
    ]
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue'),
    meta: {
      title: '登录',
      icon: '',
      hidden: true,
      hiddenTab: true
    }
  },
  // 个人中心
  {
    path: '/user',
    component: () => import('@/layout/index.vue'),
    redirect: '/user/userInfo',
    meta: {
      title: '个人中心',
      icon: 'user',
      hidden: true,
      hiddenTab: true
    },
    children: [{
      path: 'userInfo',
      name: 'userInfo',
      component: () => import('@/views/userCenter/userInfo.vue'),
      meta: {
        title: '个人中心',
        icon: ''
      },
    }]
  },
  
  {
    path: '/:path(.*)*',
    component: () => import('@/views/err/404.vue'),
    meta: {
      title: '404',
      icon: '',
      hidden: true,
      hiddenTab: true
    }
  }
]
